import { isSameDay } from "./IsSameDay";

/**
 * Returns a CSS class if the given date equals "today" in the provided time zone, otherwise an empty string.
 *
 * @param date - The date to check.
 * @param timeZone - The time zone for comparison (default: "Europe/Berlin").
 * @param className - The CSS class to return when the date is today (default: "today").
 */
export function todayClass(
    date: Date,
    timeZone: string = "Europe/Berlin",
    className: string = "today"
): string {
    return isSameDay(date, new Date(), timeZone) ? className : "";
}
